export default {
  COURSE: 'course_subscription',
  CONSULTATION: 'expert_additional_question'
}
